import { createContext, useContext } from "react";

/**
 * Оцветяваме ли етикета с името на дневното меню (`LunchTag`) в кутийките на
 * продуктите — следва настройката като самите кутийки: в „Маркиране" —
 * „Оцветяване на асортиментите" (`colorBy`), в монитора — неговото оцветяване;
 * „Без" → неутрален етикет. Бутоните на менютата над каталога НЕ я следват —
 * те са винаги в цвета на менюто. Без доставчик — оцветяваме.
 */
export const LunchMenuColoringContext = createContext(true);

export const useLunchMenuColoring = () => useContext(LunchMenuColoringContext);
